import { EnumWithDescription, ICustomEnumValue } from "../EnumWithDescription";

export enum AdvanceDirectivesEnum {
    None = 0,
    LivingWill = 1,
    PowerOfAttorney = 4,
    PhysicianOrdersForLST = 8,
    MedicalOrdersForLST = 16,
    OtherLegalDocuments = 32
}

export class AdvanceDirectivesEnumClass extends EnumWithDescription<AdvanceDirectivesEnum> {
    public readonly enum = AdvanceDirectivesEnum;
    public readonly enumName: string = "AdvanceDirectives";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<AdvanceDirectivesEnum>> = new Map([
        [
            "None",
            {
                value: AdvanceDirectivesEnum.None,
                name: "None"
            }
        ],
        [
            "Living Will",
            {
                value: AdvanceDirectivesEnum.LivingWill,
                name: "LivingWill"
            }
        ],
        [
            "Power of Attorney",
            {
                value: AdvanceDirectivesEnum.PowerOfAttorney,
                name: "PowerOfAttorney"
            }
        ],
        [
            "Physician Orders for Life Sustaining Treatment",
            {
                value: AdvanceDirectivesEnum.PhysicianOrdersForLST,
                name: "PhysicianOrdersForLST"
            }
        ],
        [
            "Medical Orders for Life Sustaining Treatment",
            {
                value: AdvanceDirectivesEnum.MedicalOrdersForLST,
                name: "MedicalOrdersForLST"
            }
        ],
        [
            "Other Legal Documents",
            {
                value: AdvanceDirectivesEnum.OtherLegalDocuments,
                name: "OtherLegalDocuments"
            }
        ]
    ]);
}

export const AdvanceDirectives = new AdvanceDirectivesEnumClass();
